<div class="modal-body on_Modal_css">
  <app-change-viewer-analytic [regulationData]="regulationData"></app-change-viewer-analytic>
</div>
